import { GridValidRowModel } from "@mui/x-data-grid";
import { deleteRecipientGroup } from "src/api/contractSweepRecipientSetting";
import DialogInOne from "src/components/DialogInOne";
import { useAssets } from "src/components/FetchConfig";
import Prompter from "src/components/Prompter";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useAlerting, useTranslation, useYubiPrompt } from "src/hooks";
import { appError } from "src/utils/errorHandler";
import { useZusDialogStore } from "src/zustand/store";
import { GetListRes } from "../types/GetListRes";

type Props = {
  isOpen: boolean;
  selectedRow: (GridValidRowModel & { rawData: GetListRes }) | undefined;
  onClose: () => void;
};

const useDeleteGroupDialog = (props: Props) => {
  const { isOpen, selectedRow, onClose } = props;
  const { translatePrefix, onFilterSearch } = usePageConfigProviderContext();
  const { getResAfterYubi, prompterConfig } = useYubiPrompt();
  const zusDialog = useZusDialogStore();
  const { t } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();

  const { selectAssetsByChain } = useAssets();
  const { chain_id, chain_type } = selectedRow?.rawData ?? {};
  const assets = selectAssetsByChain({ chain_type, chain_id });
  const selectedAsset = assets.find(
    (item) => item.asset_name === selectedRow?.rawData.asset_name,
  );

  const onConfirm = async () => {
    zusDialog.openExtra("loadingDialog");
    const res: any = await getResAfterYubi(
      deleteRecipientGroup,
      {
        id: selectedRow?.rawData?.id,
        decimals: selectedAsset?.decimals,
        actionConfirmed: false,
      },
      {
        isSkipErrorHandling: true,
      },
    );
    zusDialog.closeExtra();

    if (!res) return;

    if ((res as any).error?.code === -69) {
      return alerting("warning", t("active_group_cannot_be_deleted_disabled"));
    }

    if (!res || (res as any).error) {
      return appError({
        ...(res as any).error,
        requestId: (res as any).requestId,
      });
    }

    if (res) {
      alerting("success", t("delete_record_success"));
      onFilterSearch();
      onClose();
    }
  };

  const renderDeleteDialog = () => {
    return (
      <>
        <Prompter {...prompterConfig} />
        <DialogInOne
          title={t("confirm_to_delete")}
          self={{
            open: isOpen,
            onClose: onClose,
          }}
          maxWidth="xs"
          content={<></>}
          onConfirm={onConfirm}
          onCancel={onClose}
        />
      </>
    );
  };
  return { renderDeleteDialog };
};

export default useDeleteGroupDialog;
